<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="true" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail-manual">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="mw-75">
      @if (showEigentumHeaderWithText) {
        <span>{{ "Eigentum" | translate }}</span>
      }
    </th>
    <th style="width: 6%">
      <span class="float-end pe-3">{{ "Anteil" | translate }}</span>
    </th>
    @if (hasParzellenindex) {
      <th style="width: 6%">{{ "Index" | translate }}</th>
    }
    @if (showBelegColumn) {
      <th [style]="'width: 14%;'">
        {{ "DatumOderBelegOderRechtsgrund" | translate }}
      </th>
    } @else {
      <th style="width: 16%"></th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (eigentumanteilMaster of listLoader?.items; track eigentumanteilMaster; let i = $index) {
    <ng-template
      [ngTemplateOutlet]="berechtigtesGrundstueckTemplate"
      [ngTemplateOutletContext]="{ eigentumanteilMaster: eigentumanteilMaster, odd: i % 2 }">
    </ng-template>
  }
</ng-template>

<ng-template #berechtigtesGrundstueckTemplate let-eigentumanteilMaster="eigentumanteilMaster" let-odd="odd">
  @for (eigentumanteilVersion of eigentumanteilMaster.versionenVm; track eigentumanteilVersion) {
    <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
      <td>
        <span [capHistinfo]="eigentumanteilVersion.object.histInfo" [ngStyle]="eigentumanteilMaster.indent" class="mitHistPrefix">
          @if (eigentumanteilMaster.grundstueckEigentum) {
            <cap-kompakt-grundstueck
              [item]="eigentumanteilMaster.object.berechtigtesGrundstueck.grundstueck"
              [navigateTo]="navigateToGrundstueck">
            </cap-kompakt-grundstueck>
          }
          {{ eigentumanteilVersion.art }}
          @if (eigentumanteilMaster.berechtigtesGrundstueckVm?.object.subjektivDinglich) {
            ({{ "grundstueck.eigentum.DominierendesGrundstueck" | translate }})
          }
        </span>
        @if (showHistorischeDaten) {
          <cap-kompakt-timepoint [item]="eigentumanteilVersion.object.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        }
      </td>
      <td>
        <span [capHistinfo]="eigentumanteilVersion.object.histInfo" class="float-end pe-3">
          {{ eigentumanteilVersion.quoteValue }}
        </span>
      </td>
      @if (hasParzellenindex) {
        <td [capHistinfo]="eigentumanteilVersion.object.histInfo">
          {{ eigentumanteilVersion.object.parzellenindex }}
        </td>
      }
      <td>
        @if (showBelegColumn) {
          @if (eigentumanteilMaster.hasRightRechtsgruende) {
            @if (eigentumanteilVersion.showContent) {
              @for (rechtsgrund of eigentumanteilMaster?.object.rechtsgruende; track rechtsgrund) {
                <div>
                  @if (rechtsgrund && rechtsgrund.histInfo) {
                    <p class="mb-0">
                      <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                    </p>
                  }
                </div>
              }
            }
          } @else {
            {{ "gemaessGrundbuch" | translate }}
          }
        }
      </td>
    </tr>
    @if (eigentumanteilVersion.showContent) {
      @for (
        belastendeEigentumanteilMaster of eigentumanteilMaster.berechtigtesGrundstueckVm?.belastendeEigentumsanteileVm;
        track belastendeEigentumanteilMaster
      ) {
        <ng-template
          [ngTemplateOutlet]="berechtigtesGrundstueckTemplate"
          [ngTemplateOutletContext]="{ eigentumanteilMaster: belastendeEigentumanteilMaster, odd: odd }">
        </ng-template>
      }
      @for (eigentuemer of eigentumanteilMaster.berechtigtePersonenVm; track eigentuemer) {
        <ng-template
          [ngTemplateOutlet]="berechtigtePersonTemplate"
          [ngTemplateOutletContext]="{ personGbMaster: eigentuemer.personGbMasterVm, odd: odd }">
        </ng-template>
      }
      @if (
        (eigentumanteilVersion.object.rechtBemerkung || eigentumanteilVersion.object.rechtBemerkungNichtOeffentlich) &&
        eigentumanteilVersion.showContent
      ) {
        <tr [ngClass]="{ even: !odd, odd: odd }">
          <td>
            <span style="padding-left: 10px"> {{ "grundstueck.eigentum.Bemerkungen" | translate }}: </span>
            <br />
            @if (eigentumanteilVersion.object.rechtBemerkungNichtOeffentlich) {
              <p style="padding-left: 20px; margin-bottom: 0px">
                <cap-read-more
                  [histInfo]="eigentumanteilVersion.object.histInfo"
                  [limit]="100"
                  [texts]="[eigentumanteilVersion.object.rechtBemerkung, eigentumanteilVersion.object.rechtBemerkungNichtOeffentlich]">
                </cap-read-more>
              </p>
            } @else {
              <p style="padding-left: 20px; margin-bottom: 0px">
                <cap-read-more
                  [histInfo]="eigentumanteilVersion.object.histInfo"
                  [limit]="100"
                  [text]="eigentumanteilVersion.object.rechtBemerkung">
                </cap-read-more>
              </p>
            }
          </td>
          <td></td>
          @if (hasParzellenindex) {
            <td></td>
          }
        </tr>
      }
    }
    @if (eigentumanteilMaster.hasExterneHinweise && eigentumanteilVersion.showContent) {
      <tr [ngClass]="{ even: !odd, odd: odd }">
        <td>
          <span style="padding-left: 10px"> {{ "grundstueck.eigentum.ExterneHinweise" | translate }}: </span>
          <br />
          <span style="padding-left: 20px">
            @for (gruppe of eigentumanteilMaster.externeHinweiseGruppen; track gruppe) {
              {{ gruppe.code?.text | translateName }}:
              @for (textEntry of gruppe.values; track textEntry; let last = $last) {
                <span [capHistinfo]="textEntry.object.histInfo">
                  {{ textEntry.object.text }}
                </span>
                @if (!last) {
                  <span>,</span>
                }
              }
            }
          </span>
        </td>
        <td></td>
        @if (hasParzellenindex) {
          <td></td>
        }
      </tr>
    }
  }
</ng-template>

<ng-template #berechtigtePersonTemplate let-odd="odd" let-personGbMaster="personGbMaster">
  @for (personGbVersion of personGbMaster?.versionenVm; track personGbVersion) {
    <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
      <td>
        <span [ngStyle]="personGbMaster.indent">
          <cap-kompakt-persongb
            [auskunftsperre]="hasAuskunftsperre(personGbMaster.object.hasAuskunftssperre)"
            [capHistinfo]="personGbVersion.object.histInfo"
            [item]="personGbVersion.object"
            [itemMasterId]="personGbMaster.object.id"
            format="PERSONGB_TYP00">
          </cap-kompakt-persongb>
          @if (showAdressen && personGbMaster.personStamm?.adressen[0]) {
            <div>
              <cap-kompakt-personenadresse
                [auskunftsperre]="hasAdresssperre(personGbMaster.isAddresseGesperrt)"
                [entry]="personGbMaster.personStamm?.version"
                [format]="'PERSONENADRESSE_TYP01'"
                [item]="personGbMaster.personStamm?.adressen[0]"
                [ngStyle]="personGbMaster.indent">
              </cap-kompakt-personenadresse>
            </div>
          }
          @if (showHistorischeDaten) {
            <cap-kompakt-timepoint [item]="personGbVersion.object.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
          }
        </span>
      </td>
      <td></td>
      @if (hasParzellenindex) {
        <td></td>
      }
      <td>
        @if (showBelegColumn) {
          @if (personGbVersion.showContent) {
            @for (rechtsgrund of personGbMaster?.rechtsgruende | uniqueErwerbsgrundPipe; track rechtsgrund) {
              <div>
                @if (rechtsgrund && rechtsgrund.histInfo) {
                  <p class="mb-0">
                    <cap-rechtsgrund [ohneLoeschgeschaeft]="!showHistorischeDaten" [rechtsgrund]="rechtsgrund"> </cap-rechtsgrund>
                  </p>
                }
              </div>
            }
          }
        }
      </td>
    </tr>
    @for (mitglieder of personGbMaster?.mitgliederVm; track mitglieder) {
      <ng-template [ngTemplateOutlet]="berechtigtePersonTemplate" [ngTemplateOutletContext]="{ personGbMaster: mitglieder, odd: odd }">
      </ng-template>
    }
  }
</ng-template>
